<template>
  <header class="bg-background-darker flex h-6 w-full justify-between px-4">
    <div>
      This is just some demo to help me debug which recipes are actually used, double click row in
      top to tables to select
    </div>
    <a href="https://github.com/Kvan7/test-remnants">Github</a>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
